import React from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  title: 'Pediatric Therapy Activity Vault™',
  description: 'A complete collection of engaging activities for fine motor, gross motor, and school readiness, including materials lists and step-by-step instructions for the pediatric setting.'
}, {
  title: 'Sensory Integration Toolkit™',
  description: 'A professional collection of sensory diets, regulation strategies, sensory circuits, and environmental modification guides designed to help patients achieve an optimal state of arousal.'
}, {
  title: 'Home Program Templates™',
  description: 'A collection of professional, printable home exercise programs and caregiver instruction sheets to ensure 24/7 carryover and improved patient outcomes.'
}, {
  title: 'Clinical Documentation Master Pack™',
  description: 'A comprehensive set of professional documentation resources including SOAP note starters, assessment phrase banks, and standardized reporting tools to slash your paperwork time.'
}, {
  title: 'Private Practice Success Toolkit™',
  description: 'Essential systems for the independent therapist, including intake workflows, caseload dashboards, and productivity checklists to keep your practice running efficiently.'
}];
const outcomes = [{
  emoji: '⚡',
  title: 'Save Hours Every Week',
  desc: 'Stop building therapy programs, planning sessions, and creating home programs from scratch. Simply open the system, choose the right plan, and step into your clinic fully prepared.'
}, {
  emoji: '👑',
  title: 'Treat With Greater Confidence',
  desc: 'Deliver every session with professional structure, use proven clinical frameworks, organize every phase of treatment, and confidently lead every intervention with a system built specifically for OTs.'
}, {
  emoji: '💪',
  title: 'Help Your Patients Achieve More',
  desc: 'Support greater functional independence through structured programming, progressive intervention systems, and professional resources that focus on meaningful occupational outcomes.'
}, {
  emoji: '😊',
  title: 'Deliver More Professional Sessions',
  desc: 'Keep your clinical practice organized with ready-to-use resources, structured treatment plans, and professional documentation templates that create an efficient and high-level environment.'
}];
export function BonusSection() {
  return <>
      <section className="border-y border-brand-gold/30 bg-brand-cloud px-4 py-6" data-id="element-15" data-mp="te2vkw0m3d6i">
        <div className="mx-auto max-w-4xl" data-id="element-16" data-mp="1757m98m04v4p">
          <div className="mb-4 text-center" data-id="element-17" data-mp="17698884k3217">
            <h2 className="mb-1 text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-18" data-mp="17729wuonr1ch">
              5 PREMIUM BONUSES INCLUDED
            </h2>
            <p className="mx-auto max-w-3xl text-sm font-medium leading-snug text-brand-slate sm:text-base" data-id="element-19" data-mp="eo51jzg03t9e">
              You'll also receive 5 premium bonuses designed to help you save even more planning time, improve every session, and deliver a more professional therapeutic experience.
            </p>
          </div>
          <div className="grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="5awhgjoktqcr">
            {bonuses.map((bonus, i) => <article key={bonus.title} className="rounded-xl border border-brand-gold/40 bg-white p-3 text-center shadow-sm" data-id="element-21" data-mp="3msfps5gpc2s4" data-mpi={i}>
                <div className="mx-auto mb-2 flex h-9 w-9 items-center justify-center rounded-full border border-brand-gold/40 bg-brand-gold/15" data-id="element-22" data-mp="j9w7nvrqmdb1">
                  <GiftIcon className="h-4 w-4 text-brand-gold" data-id="element-23" data-mp="o7xm23e7xog6" />
                </div>
                <h3 className="mb-1 text-sm font-bold leading-tight text-brand-ink" data-id="element-24" data-mp="9chpnrq61ggm">
                  🎁 BONUS {i + 1} — {bonus.title}
                </h3>
                <p className="text-xs font-medium leading-snug text-brand-slate" data-id="element-25" data-mp="ecmb7w5xl1dp">
                  {bonus.description}
                </p>
              </article>)}
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-6" data-id="element-26" data-mp="3f7wqtjc4hked">
        <div className="mx-auto max-w-4xl" data-id="element-27" data-mp="3f9pvwu737wk9">
          <h2 className="mb-4 text-center text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-28" data-mp="3ahq3dmtck5xp">
            WHAT WILL CHANGE
          </h2>
          <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-29" data-mp="35jerl6jhrlcu">
            {outcomes.map(item => <div key={item.title} className="flex gap-3 rounded-r-xl border-l-4 border-brand-blue bg-brand-cloud p-3 shadow-sm" data-id="element-30" data-mp="30kbkzhnv572r">
                <span className="mt-0.5 shrink-0 text-xl" aria-hidden="true" data-id="element-31" data-mp="20v6qp357hs2">{item.emoji}</span>
                <div data-id="element-32" data-mp="3t8pjdyiv65eu">
                  <h3 className="mb-0.5 text-sm font-extrabold uppercase tracking-wide text-brand-ink sm:text-base" data-id="element-33" data-mp="3t63b1wo5flvk">
                    {item.title}
                  </h3>
                  <p className="text-xs font-medium leading-snug text-brand-slate sm:text-sm" data-id="element-34" data-mp="3j9i95k7feqvy">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}